var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMantle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4335_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.93969 8.41518L1.3002 6.56201C1.01463 7.121 0.774631 7.70733 0.5802 8.30581L4.46577 9.56353C4.59337 9.16859 4.75134 8.78277 4.93969 8.41518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02941 5.14943L10.0436 8.62184C10.3383 8.45171 10.6542 8.32108 10.9793 8.23298L9.93726 4.35652C10.2016 4.28665 10.4719 4.22589 10.7454 4.18336L10.1043 0.148926C9.4846 0.246141 8.86789 0.395002 8.27245 0.589432L9.51802 4.41121C9.12005 4.54184 8.73422 4.70285 8.36359 4.8912L6.53473 1.31551C5.97878 1.60108 5.43802 1.93222 4.93372 2.30285L7.33979 5.59905C7.56156 5.43804 7.79245 5.28918 8.02941 5.14943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8476 8.02622L15.3752 10.0434C15.5454 10.3381 15.679 10.6541 15.7671 10.9791L19.6436 9.93407C19.7165 10.1984 19.7742 10.4688 19.8168 10.7391L23.8512 10.0981C23.754 9.47838 23.6051 8.86167 23.4076 8.26622L19.5889 9.51787C19.4583 9.11989 19.2973 8.73407 19.1089 8.36344L22.6846 6.5285C22.399 5.97255 22.0679 5.43179 21.6973 4.92749L18.4011 7.3366C18.559 7.55838 18.7079 7.78926 18.8476 8.02622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.432 1.29715C16.873 1.01158 16.2866 0.771579 15.6882 0.577148L14.4335 4.46272C14.8254 4.59031 15.2112 4.74829 15.5818 4.93664L17.432 1.29715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9798 5.07958L13.9413 8.61882C14.236 8.78894 14.5094 8.99856 14.7494 9.23856L20.4669 3.49983C20.0233 3.05629 19.5403 2.64616 19.036 2.27856L16.6785 5.53223C16.4537 5.36818 16.2228 5.21629 15.9798 5.07958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07947 8.0143L8.61567 10.0558C8.7858 9.76113 8.99542 9.48771 9.23542 9.24468L3.50276 3.52417C3.05922 3.96771 2.64909 4.45075 2.28149 4.95506L5.53213 7.31556C5.37111 7.54037 5.21922 7.7743 5.07947 8.0143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2364 4.11342L13.8531 0.142784C13.2425 0.048607 12.6197 0 11.9969 0H11.9878V8.09924H11.9969C12.3372 8.09924 12.6774 8.14177 13.0025 8.22987L14.0506 4.28354C13.7832 4.21063 13.5129 4.15595 13.2364 4.11342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22987 10.9945L4.28354 9.94336C4.21367 10.2107 4.15595 10.4841 4.11342 10.7575L0.142784 10.1378C0.048607 10.7484 0 11.3773 0 12.0001H8.09924C8.09924 11.6568 8.14481 11.3196 8.22987 10.9945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0603 15.5849L22.6998 17.438C22.9854 16.8791 23.2254 16.2927 23.4198 15.6942L19.5342 14.4365C19.4066 14.8315 19.2487 15.2173 19.0603 15.5849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9676 18.8476L13.9534 15.3752C13.6587 15.5454 13.3428 15.676 13.0177 15.7641L14.0597 19.6406C13.7954 19.7104 13.525 19.7712 13.2516 19.8137L13.8926 23.8482C14.5124 23.7509 15.1291 23.6021 15.7245 23.4076L14.479 19.5859C14.8769 19.4552 15.2628 19.2942 15.6334 19.1059L17.4653 22.6816C18.0212 22.396 18.562 22.0649 19.0663 21.6942L16.6602 18.395C16.4385 18.5621 16.2076 18.7109 15.9676 18.8476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15235 15.9738L8.62475 13.9535C8.45463 13.6588 8.32096 13.3429 8.23286 13.0178L4.3564 14.0629C4.28349 13.7986 4.22577 13.5282 4.18324 13.2578L0.148804 13.8988C0.246019 14.5186 0.39488 15.1353 0.592348 15.7307L4.41108 14.4821C4.54172 14.8771 4.70273 15.2659 4.89108 15.6366L1.31539 17.4715C1.60096 18.0274 1.93209 18.5682 2.30273 19.0725L5.59893 16.6634C5.44096 16.4416 5.29209 16.2107 5.15235 15.9738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56812 22.7027C7.1271 22.9883 7.71343 23.2283 8.31191 23.4227L9.5666 19.5372C9.1747 19.4096 8.78887 19.2516 8.41824 19.0632L6.56812 22.7027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01724 18.9205L10.0557 15.3812C9.76104 15.2111 9.48762 15.0015 9.24762 14.7615L3.53015 20.5002C3.9737 20.9438 4.45673 21.3539 4.96104 21.7215L7.31851 18.4678C7.54332 18.6288 7.77724 18.7807 8.01724 18.9205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9174 15.9859L15.3812 13.9443C15.2111 14.239 15.0015 14.5124 14.7615 14.7555L20.4972 20.476C20.9407 20.0324 21.3508 19.5494 21.7184 19.0451L18.4678 16.6846C18.6288 16.4567 18.7807 16.2259 18.9174 15.9859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9944 15.77L9.94629 19.7163C10.2136 19.7862 10.4871 19.8439 10.7605 19.8865L10.1438 23.8571C10.7544 23.9513 11.3772 23.9999 12 23.9999H12.0091V15.9007H12C11.6597 15.9007 11.3195 15.8551 10.9944 15.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9008 12C15.9008 12.3433 15.8582 12.6805 15.7701 13.0056L19.7165 14.0567C19.7863 13.7894 19.8441 13.5159 19.8866 13.2425L23.8572 13.8623C23.9514 13.2516 24 12.6228 24 12H15.9008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4335_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMantle);
export default __webpack_public_path__ + "static/media/mantle.c713a526b6a0829aa4551de402302693.svg";
export { ForwardRef as ReactComponent };